// Pagination.tsx
import { cn } from "@/utils"
import React from "react"
import { FormattedMessage } from "react-intl"
import "./index.sass"

export interface PaginationProps {
  currentPage: number
  totalPages: number
  perPage?: number
  onPageChange: (page: number) => void
}

const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, perPage = 5, onPageChange }) => {
  const pageNumbers = []
  const ellipsis = "..."

  if (totalPages <= perPage) {
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i)
    }
  } else if (totalPages <= 3) {
    pageNumbers.push(
      ...Array(totalPages)
        .fill(1)
        .map((_, idx) => idx + 1),
    )
  } else {
    if (currentPage <= 2) {
      pageNumbers.push(1, 2, 3, ellipsis, totalPages)
    } else if (currentPage >= totalPages - 2) {
      pageNumbers.push(1, ellipsis, totalPages - 2, totalPages - 1, totalPages)
    } else {
      pageNumbers.push(1, ellipsis, currentPage - 1, currentPage, currentPage + 1, ellipsis, totalPages)
    }
  }

  return (
    <div className="pagination">
      {currentPage > 1 && (
        <button className="prev-item" onClick={() => onPageChange(currentPage - 2)}>
          <FormattedMessage id="prev" />
        </button>
      )}
      {pageNumbers.map((page, index) => (
        <button
          key={index}
          onClick={() => typeof page === "number" && onPageChange(page - 1)}
          className={cn(typeof page !== "number" && "disabled-item", currentPage === page && "active-item")}
        >
          {page}
        </button>
      ))}
      {currentPage < totalPages && (
        <button className="next-item" onClick={() => onPageChange(currentPage)}>
          <FormattedMessage id="next" />
        </button>
      )}
    </div>
  )
}

export default Pagination
